define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/FormData",
	"csi/def/Tab",
	"csi/table/AggregateFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"Apparel/StructureItemMixin"
], function(array,declare,lang,FormData,Tab,AggregateFrom,ActionControllerMixin,xml,StructureItemMixin) {

	return declare([AggregateFrom, ActionControllerMixin, StructureItemMixin], {
		defaultsAttribute: "Suppliers",
		limitAttribute: "LimitSuppliers",

		// FormData: form data for supplier-item templates
		_fdTemplates: null,

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	nPage = wizard.getIndexOfPage(nextPage);
			var	bRefresh = false;
			var	fd;

			switch (nPage) {
			// SELECT SUPPLIER
			case 0:
				var	action = this._resolveSourceAction(this.getParent(), this.m_cache, true);

				fd = this.m_formData;
				fd.m_bRequireOne = true;

				// set view to get suppliers - either from defaults or site
				nextPage.defTab = lang.mixin(new Tab(), {
					m_idView: action.m_viewRef.m_id,
					m_url: action.m_viewRef.m_url
				});
				nextPage.refreshTab(wizard.getContext());

				// apply appropriate filters
				// FIX: move to getWizardViewQuery?
				nextPage.getView(wizard).relRoot.addFilters(action.m_fixedQuery ? action.m_fixedQuery.getElements() : null, this.m_cache, null);
				break;

			// SELECT Supplier Item TEMPLATE
			case 1:
				fd = this._fdTemplates || (this._fdTemplates = new FormData(this));
				break;
			}

			// set form data for next page in wizard and refresh view if necessary
			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		toWriterRequest: function() {
			// summary: add selected supplier-item template to request if any
			var	call = this.inherited(arguments);
			const sourceName = this.generateSourceName();

			if (this._fdTemplates) {
				var templateNodes = this._fdTemplates.getSelectedNodes();
				if (templateNodes.length) {
					var templateUrls = [];
					array.forEach(templateNodes, function(node) {
						templateUrls.push(xml.nodeGetURL(node));
					}, this);
					call.addParameter("TemplateURLs", xml.ATTR_REFLIST, templateUrls);
				}
			}
			call.addParameter("Name", xml.ATTR_STRING, sourceName);
			this.setProgress();
			return call;
		},
		
		postProcessSuccess: function() {
			// summary: this operation does not know the URLs of the new items, so refresh whole table
			// FIX - either pass in URLs to use for new items, or detect them from response 
			this.widget.refreshWidget(true);
		},

		generateSourceName() {
			const { m_cache } = this;
			const fd = this.m_formData;
			const sourceURL = this.m_urlNode;
			const sourceNode = m_cache.getNode(sourceURL);
			const factoryURL = xml.isValidURL(sourceNode.Factory);
			const factoryNode = m_cache.getNode(sourceNode.Factory)
			const sourceName = factoryURL ? factoryNode.$Name : sourceNode.$Name;

			return sourceName;
		}
	});
});